'use client'

import dynamic from 'next/dynamic'

import '@/components/LandingPage/ContentModel/Box/Accordion/Accordion.scss'
import { Props } from '@/components/LandingPage/ContentModel/ContentModelLogic'
import '@/components/LandingPage/ContentModels.scss'

const ContentModelLogic = dynamic(() => import('@/components/LandingPage/ContentModel/ContentModelLogic'), {
  ssr: true,
})

export default function ContentModel({
  contentModel,
  baseline = true,
  optimizer = {},
  firstView = false,
  product = null,
  campaign = null,
}: Props) {
  return (
    <>
      <ContentModelLogic
        contentModel={contentModel}
        product={product}
        campaign={campaign}
        baseline={baseline}
        optimizer={optimizer}
        firstView={firstView}
      />
    </>
  )
}
